import { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import type { ModalFooterOnClickHandler } from 'LuxKit/Modal/ModalFooter'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import TierProgressionInfoModalContent from './TierProgressionInfoModalContent'

interface Props {
  tiers: Array<App.LoyaltyTier>
  defaultExpandedTier?: App.LoyaltyTier
  onBookNow?: () => void
  onAddToCart?: () => void
  checkoutDate?: string
}

function TierProgressionInfoModal({ tiers, defaultExpandedTier, onBookNow, onAddToCart, checkoutDate }: Props) {
  const intl = useIntl()
  const programDisplayName = getLoyaltyProgramDisplayName()

  const handleBookNow = useCallback<ModalFooterOnClickHandler>((e, resolve) => {
    resolve()
    onBookNow?.()
  }, [onBookNow])

  const handleAddToCart = useCallback<ModalFooterOnClickHandler>((e, resolve) => {
    resolve()
    onAddToCart?.()
  }, [onAddToCart])

  const bookNowText = (
    <FormattedMessage
      id="RXnnY1ws1cbaVNnOj246"
      defaultMessage="Book now"
      
    />
  )

  const addToCartText = (
    <FormattedMessage
      id="hs0WtPgRbe6Y_Ho9ClTh"
      defaultMessage="Add to cart"
      
    />
  )

  return (
    <Modal
      title={intl.formatMessage({
        id: 'Ppqq2OT1K5tZmAwITQNy',
        defaultMessage: '{programName} Status upgrade',
      }, { programName: programDisplayName })}
      primaryActionText={onBookNow ? bookNowText : undefined}
      secondaryActionText={onAddToCart ? addToCartText : undefined}
      onPrimaryActionClick={onBookNow ? handleBookNow : undefined}
      onSecondaryActionClick={onAddToCart ? handleAddToCart : undefined}
    >
      <TierProgressionInfoModalContent
        tiers={tiers}
        defaultExpandedTier={defaultExpandedTier}
        checkoutDate={checkoutDate}
      />
    </Modal>
  )
}

export default TierProgressionInfoModal
